import styles from './styles.module.scss';

const ProductCardLoading: React.FC = () => (
  <div data-cy="product-loading" className={styles['loadingCard']}>
    <div className={styles['loadingIcon']} />
    <div className={styles['loadingProductSummary']} />
    <div className={styles['loadingDetailsButton']} />
  </div>
);

export default ProductCardLoading;
